import { render } from "./IconFile.vue?vue&type=template&id=d7288cfc&ts=true"
import script from "./IconFile.vue?vue&type=script&lang=ts"
export * from "./IconFile.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__